import { DialogClose } from '@radix-ui/react-dialog'
import { GlobalSearch } from './global-search'
import { ModalModeProvider } from './modal-mode-context'
import { Dialog, DialogContent, DialogHeader } from './ui/dialog'

export const SearchModalDialog = ({
  isOpen,
  open,
  close,
}: {
  isOpen: boolean
  open: () => void
  close: () => void
}) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(isOpen) => (isOpen ? open() : close())}
    >
      <DialogContent
        aria-describedby='search modal'
        className='sm:max-w-lg max-h-none h-full sm:h-fit bg-background supports-[backdrop-filter]:bg-background-80 backdrop-blur-xl dark:border-1 dark:border-border1 sm:rounded-3xl focus:outline-none shadow-2xl'
        closeAction={close}
        showBackButton={false}
        showCloseButton={true}
        hideHeader={true}
      >
        <DialogHeader className='sm:hidden absolute top-0 right-0 flex items-center justify-end z-50'>
          <DialogClose className='px-5 py-3 link text-base font-semibold'>
            Cancel
          </DialogClose>
        </DialogHeader>
        <ModalModeProvider>
          <GlobalSearch close={close} />
        </ModalModeProvider>
      </DialogContent>
    </Dialog>
  )
}
